import React from "react";
import { useI18n } from "@/i18n/I18nContext";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import SEO from "@/components/seo/SEO";

export default function CookiePolicy() {
  const { language } = useI18n();
  const fr = (
    <div className="prose prose-sm max-w-none text-foreground">
      <h1 className="font-heading text-2xl font-medium">Gestion des cookies</h1>
      <p className="mt-4 text-muted-foreground">Kalypso Music utilise un nombre limité de cookies et technologies similaires, strictement nécessaires au fonctionnement du site ou à des fins de mesure d'audience.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">1. Cookies essentiels</h2>
      <p className="mt-2 text-muted-foreground">Cookie de session (connexion sécurisée) : indispensable pour rester connecté à votre compte. Ce cookie ne peut pas être désactivé.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">2. Mesure d'audience</h2>
      <p className="mt-2 text-muted-foreground">Google Analytics (GA4) est utilisé pour comprendre l'utilisation du site de façon anonymisée et améliorer l'expérience utilisateur.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">3. Notifications push</h2>
      <p className="mt-2 text-muted-foreground">Si vous acceptez les notifications, un identifiant technique est stocké pour vous envoyer des alertes (musique prête, jetons reçus...). Vous pouvez révoquer cette autorisation à tout moment dans les réglages de votre navigateur ou appareil.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">4. Gestion</h2>
      <p className="mt-2 text-muted-foreground">Vous pouvez à tout moment supprimer les cookies via les paramètres de votre navigateur.</p>
    </div>
  );
  const en = (
    <div className="prose prose-sm max-w-none text-foreground">
      <h1 className="font-heading text-2xl font-medium">Cookie Policy</h1>
      <p className="mt-4 text-muted-foreground">Kalypso Music uses a limited number of cookies and similar technologies, strictly necessary for the site to work or for audience measurement.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">1. Essential cookies</h2>
      <p className="mt-2 text-muted-foreground">Session cookie (secure login): required to stay logged into your account. This cookie cannot be disabled.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">2. Audience measurement</h2>
      <p className="mt-2 text-muted-foreground">Google Analytics (GA4) is used to understand site usage anonymously and improve the user experience.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">3. Push notifications</h2>
      <p className="mt-2 text-muted-foreground">If you accept notifications, a technical identifier is stored to send you alerts (song ready, tokens received...). You can revoke this permission at any time in your browser or device settings.</p>
      <h2 className="mt-6 font-heading text-lg font-medium">4. Management</h2>
      <p className="mt-2 text-muted-foreground">You can delete cookies at any time via your browser settings.</p>
    </div>
  );

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <SEO title={language === "en" ? "Cookie Policy | Kalypso Music" : "Politique de cookies | Kalypso Music"} description={language === "en" ? "How Kalypso Music uses cookies on kalypsomusic.com." : "Comment Kalypso Music utilise les cookies sur kalypsomusic.com."} path="/cookies" />
      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6">{language === "en" ? en : fr}</main>
      <Footer />
    </div>
  );
}
